import { render, staticRenderFns } from "./ResultsStudentPreparate.vue?vue&type=template&id=592c8648&scoped=true&"
import script from "./ResultsStudentPreparate.vue?vue&type=script&lang=js&"
export * from "./ResultsStudentPreparate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592c8648",
  null
  
)

export default component.exports